import * as angular from 'angular';

const defaultToolbar = [
    ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'],
    ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
    ['bold', 'italics', 'underline', 'strikeThrough', 'ul', 'ol', 'html']
];

function taOptionsFactory(taOptions: any) {
    taOptions.toolbar = defaultToolbar;
    return taOptions;
}

taOptionsFactory.$inject = ['taOptions'];

angular.module('app.retailes.common')
    .factory('appWysiwygOptions', taOptionsFactory);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer.common/modules/services/appWysiwygOptions.factory.ts